import {Button, MenuItem, TextField} from "@mui/material";
import {LoadingButton} from "../../../../../../shared/components/Buttons";
import {
    CustomDialog,
    CustomDialogActions,
    CustomDialogContent,
    CustomDialogTitle
} from "../../../../../../shared/components/CustomDialog";
import {useAddAssetSetting} from "../../../hooks/dialogs/useAddAssetSetting";


export const AddAssetSettingDialog = () => {

    const {
        isOk,
        isTitleExist,
        isOpen,
        isLoading,
        isLoadingDataForDialog,
        job,
        status,
        jobTypeVariants,
        title, setTitle,

        handleClose,
        handleConfirm,
        handleChange,
        handleChangeStatus,
        handleSetJobType,
    } = useAddAssetSetting();




    return (
        <CustomDialog open={isOpen} onClose={handleClose} >
            <CustomDialogTitle >{'Create row'}</CustomDialogTitle>

            <CustomDialogContent >
                {!!job &&
                    <>
                        <TextField label={'New variant'} value={job?.title} size={'small'}
                                   required
                                   sx={{mt: '8px', width: '100%', '& label': {top: '0 !important'}}}
                                   helperText={isTitleExist ? 'Already exist' : undefined}
                                   error={isTitleExist}
                                   onChange={handleChange} name={'title'} />

                        <TextField label={'Job type'} size={'small'}
                                   required select
                                   value={job?.type || ''}
                                   sx={{width: '100%', mt: '12px', '& label': {top: '0 !important'}}}
                                   disabled={isLoading || isLoadingDataForDialog}
                        >
                            {jobTypeVariants ?
                                jobTypeVariants.map((e) => (<MenuItem key={e} value={e} onClick={() => {handleSetJobType(e)}}>{e}</MenuItem>))
                                : <MenuItem />
                            }
                        </TextField>

                        <TextField multiline minRows={3}
                                         value={job?.description ?? ''} onChange={handleChange}
                                         name={'description'} label={'Description'}
                                         disabled={isLoading}
                                         sx={{mt: '12px', width: '100%',
                                             '& .MuiInputBase-root': {padding: '12px'}
                                         }}/>
                        <TextField multiline minRows={3}
                                         value={job?.requirements ?? ''} onChange={handleChange}
                                         name={'requirements'} label={'Requirements'}
                                         disabled={isLoading}
                                         sx={{mt: '12px', width: '100%'}}/>

                    </>
                }

                {!!status &&
                    <>
                        <TextField label={'New variant'} value={status?.title} size={'small'}
                                   required
                                   sx={{mt: '8px', width: '100%', '& label': {top: '0 !important'}}}
                                   helperText={isTitleExist ? 'Already exist' : undefined}
                                   error={isTitleExist}
                                   onChange={handleChangeStatus} name={'title'} />
                        <TextField label={'Text color'} value={status?.textColor} size={'small'}
                                   sx={{mt: '8px', width: '100%', '& label': {top: '0 !important'}}}
                                   onChange={handleChangeStatus} name={'textColor'} />
                        <TextField label={'Background color'} value={status?.backgroundColor} size={'small'}
                                   sx={{mt: '8px', width: '100%', '& label': {top: '0 !important'}}}
                                   onChange={handleChangeStatus} name={'backgroundColor'} />

                    </>
                }
                {!job && !status &&
                    <TextField label={'New variant'} value={title} size={'small'}
                               required
                               sx={{mt: '12px', width: '100%', '& label': {top: '0 !important'}}}
                               helperText={isTitleExist ? 'Already exist' : undefined}
                               error={isTitleExist}
                               onChange={(e) => setTitle(e.target.value)} name={'title'} />
                }

            </CustomDialogContent>

            <CustomDialogActions>
                <Button variant={"text"} onClick={handleClose} disabled={isLoading} sx={{textTransform: 'none', fontWeight: 700, fontSize: '16px'}}>{'Cancel'}</Button>
                <LoadingButton disabled={!isOk} loading={isLoading} sx={{textTransform: 'none', fontWeight: 700, fontSize: '16px'}} onClick={handleConfirm}>
                    {'Confirm'}
                </LoadingButton>
            </CustomDialogActions>
        </CustomDialog>
    )
}